import React from "react";
import { useHistory } from "react-router-dom";
import HistoryIcon from "@mui/icons-material/History";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import BarChartIcon from "@mui/icons-material/BarChart";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ExtensionIcon from "@mui/icons-material/Extension";
import GroupIcon from "@mui/icons-material/Group";
import SmartToyIcon from "@mui/icons-material/SmartToy";

import { Box, Card, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const StasticsView = () => {
  const history = useHistory();
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: "auto",
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
    >
      <Grid container spacing={2}>
        {/* History Statistics Section */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              p: 2,
              fontFamily: "Roboto,sans-serif",
              borderRadius: "12px",
              border: "1px solid #EAEEF0",
              boxShadow: "none",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
              },
            }}
            onClick={() => {
              history.push("/statistics/execution");
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <HistoryIcon sx={{ mr: 1 }} />
                <Typography>Execution Statistics</Typography>
              </Box>
              <Box>
                <Typography sx={{ fontWeight: "bold" }}>&gt;</Typography>
              </Box>
            </Box>
          </Card>
        </Grid>

        {/* Automation Statistics Section */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              p: 2,
              fontFamily: "Roboto,sans-serif",
              borderRadius: "12px",
              border: "1px solid #EAEEF0",
              boxShadow: "none",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
              },
            }}
            onClick={() => {
              history.push("/statistics/automation");
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <BarChartIcon sx={{ mr: 1 }} />
                <Typography>Automation Statistics </Typography>
              </Box>
              <Box>
                <Typography sx={{ fontWeight: "bold" }}>&gt;</Typography>
              </Box>
            </Box>
          </Card>
        </Grid>

        {/* User Statistics Section */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              p: 2,
              fontFamily: "Roboto,sans-serif",
              borderRadius: "12px",
              border: "1px solid #EAEEF0",
              boxShadow: "none",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
              },
            }}
            onClick={() => {
              history.push("/statistics/user");
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <GroupIcon sx={{ mr: 1 }} />
                <Typography>User Statistics </Typography>
              </Box>
              <Box>
                <Typography sx={{ fontWeight: "bold" }}>&gt;</Typography>
              </Box>
            </Box>
          </Card>
        </Grid>

        {/* Assistant Statistics Section */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              p: 2,
              fontFamily: "Roboto,sans-serif",
              borderRadius: "12px",
              border: "1px solid #EAEEF0",
              boxShadow: "none",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
              },
            }}
            onClick={() => {
              history.push("/statistics/assistant");
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <SmartToyIcon sx={{ mr: 1 }} />
                <Typography>Assistant Statistics </Typography>
              </Box>
              <Box>
                <Typography sx={{ fontWeight: "bold" }}>&gt;</Typography>
              </Box>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StasticsView;
